<template>
  <div class="teaser-list">
    <Heading v-if="title" :level="2" :content="title" class="teaser-list-title" />
    <ol v-if="state.teasers.length > 0" class="teaser-list-teasers">
      <li
        v-for="(teaser, index) in state.teasers"
        :key="`list-item-${index}-${teaser.id}-${teaser.slug}`"
      >
        <TeaserListItem v-bind="teaser" :analytics="analytics" :show-date="true" :padded="false" />
      </li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import type { IAnalytics, ITeaser, TArticle } from '~~/types/local_types';

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  teasers: {
    type: Array as () => TArticle[] | ITeaser[],
    default: () => [],
  },
  analytics: {
    type: Object as () => IAnalytics,
    default: null,
  },
});

const state = reactive({
  teasers: props.teasers,
  title: props.title,
});
</script>

<style scoped lang="postcss">
.teaser-list {
  --teaser-list-gap: var(--unit-12);
  --teaser-list-padding: var(--unit-16) var(--unit-18) var(--unit-20) var(--unit-18);
  --teaser-list-border-width: var(--unit-4);
  --teaser-list-background: hsl(var(--color-primary-50));
  --teaser-list-border-top: 2px solid hsl(var(--color-primary-50));
  --teaser-list-border-bottom: 2px solid hsl(var(--color-primary-50));

  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--teaser-list-gap);
  border-top: var(--teaser-list-border-top);
  border-bottom: var(--teaser-list-border-top);
  padding: var(--teaser-list-padding);

  @media (--md-viewport) {
    --teaser-list-gap: var(--unit-16);
    --teaser-list-padding: var(--unit-24) 0 var(--unit-32) 0;
  }
}

.teaser-list-teasers {
  --teaser-list-teasers-gap: var(--unit-12);

  display: flex;
  flex-direction: column;
  gap: var(--teaser-list-teasers-gap);

  @media (--lg-viewport) {
    --teaser-list-teasers-gap: var(--unit-16);
  }

  width: 100%;
}

.teaser-list-title {
  color: hsl(var(--color-primary-700));
  @add-mixin heading-sm-caps;
}
</style>
